module.exports = __webpack_public_path__ + "img/settings-1_640.8bfbe6a0.webp";